import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[cvDynamicModal]',
})
export class DynamicHostDirective {
	constructor(public viewContainerRef: ViewContainerRef) {
	}
}
